/** A full page navigation, for leaving the app (a provider's consent screen). Its own module so tests can stand in for it. */
export function navigateTo(url: string) {
  window.location.assign(url)
}
